module.exports = __webpack_public_path__ + "img/tool03.cada7ee5.png";